// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1_UXu","cls2":"WinBackPing-cls2_BJg WinBackPing-cls1_UXu"};